import React, {useEffect, useRef, useState} from "react";
import {shortDateTimeFormat2} from "../../../../../util/DateTimeUtils";
import {useRpcSender} from "../../../../../util/RpcSender";
import {RpcState} from "../../../../../util/RpcState";
import {TabbedPageHeader} from "../../../../../components/TabbedPageHeader";
import {Link, useParams} from "react-router-dom";
import {
  GetBookingsResponse,
  GetClientBookingsRequest,
  MarkBookingAsPaidRequest, MarkBookingAsPaidResponse,
  space
} from "../../../../../provider_api";
import {bookingTitle, PaymentStatusWidget} from "../../../../../util/BookingUtil";
import IApiBookingProto = space.kenko.proto.IApiBookingProto;
import {LinkWithParams} from "../../../../../util/NavUtils";
import {ActionButton} from "../../../../../util/UI/ActionButton";
import {LoadingDots} from "../../../../../util/UI/LoadingDots";

export const BookingDetails = () => {

  const {bookingId} = useParams();
  const rpcSender = useRpcSender();
  const [rpcState, setRpcState] = useState<RpcState>({state: 'pending'});
  const [booking, setBooking] = useState<IApiBookingProto>();
  const [note, setNote] = useState('');

  const cancel = () => {

    if (!window.confirm('Are you sure you want to cancel this booking? TODO TODO')) {
      return;
    }

    // RefundPaymentRequest.encode(new RefundPaymentRequest({
    //   paymentId: transaction?.transactionId,
    // }));

  }

  useEffect(() => {

    const request = GetClientBookingsRequest.encode(new GetClientBookingsRequest({
      optionalBookingId: bookingId,
    })).finish()

    rpcSender.send("get_client_bookings", request)
        .then(bytes => {
          const response = GetBookingsResponse.decode(bytes);
          if (!response.okay) {
            setRpcState({state: 'error', message: 'Error loading booking'})
            return;
          }

          if (response.booking.length == 0) {
            setRpcState({state: 'error', message: 'Booking not found'});
          }

          setBooking(response.booking[0]);
          setRpcState({state: 'success'});
        })
        .catch(e => {
          console.log(e);
          setRpcState({state: 'error', message: 'Network error loading bookings: ' + e})
        })
  }, [])


  const markAsPaid = () => {

    if (!window.confirm(`Mark this booking as paid externally, with note '${note}'?`)) {
      return;
    }

    const request = MarkBookingAsPaidRequest.encode(new MarkBookingAsPaidRequest({
      bookingId: booking?.bookingId,
      paid: true,
      note: note
    })).finish()

    rpcSender.send("mark_booking_as_paid", request)
        .then(bytes => {
          const response = MarkBookingAsPaidResponse.decode(bytes);
          if (!response.okay || !response.updatedBooking) {
            setRpcState({state: 'error', message: 'Error updating booking'})
            return;
          }
          setBooking(response.updatedBooking);
          setRpcState({state: 'success'});
        })
        .catch(e => {
          console.log(e);
          setRpcState({state: 'error', message: 'Network error loading bookings: ' + e})
        })

  }

  const isUnpaid = booking?.details?.paymentInfo?.postpaidReservation;

  return <div className={'NonScrollingToolPage'}>

    {/* There is no "back to payments" button because the user may have come from two
     different locations - the "all payments" list or a client's payments list */}
    <TabbedPageHeader pageTitle={'Booking details'}/>

    <div className={'ProviderToolAreaContent'}>

      {rpcState.state == 'pending' && <div>Loading booking details<LoadingDots/></div>}
      {rpcState.state == 'error' && <div className={'ErrorText'}>{rpcState.message}</div>}
      {rpcState.state == 'success' && <>

        <div style={{display: 'flex', flexDirection: 'column', gap: 4}}>

          <div>
            <b>Name: </b>{bookingTitle(booking)}
          </div>

          <div>
            <b>Date/Time: </b>{shortDateTimeFormat2(booking?.startTimeMs)}
          </div>

          <div>
            <b>Client:</b> <LinkWithParams to={'/clients/' + booking?.userId}>{booking?.userId}</LinkWithParams>
          </div>

          <div>
            <b>Booked at:</b> {shortDateTimeFormat2(booking?.details?.bookingTimestamp)}
          </div>

          <div>
            <b>Booking ID:</b> {booking?.bookingId}
          </div>

          <div style={{display: 'flex', alignItems: 'center', gap: 6}}>
            <b>Status:</b><PaymentStatusWidget booking={booking}/>
          </div>


          <br/>


          <h2>History</h2>
          <ul>
            {booking?.details?.notes?.sort((a, b) => ((b.timestamp as number ?? 0) - (a.timestamp as number ?? 0))).map((note, i) => {
              return <li style={{marginBottom: 10}} key={'note' + i}>
                <div>{note.note}</div>
                <div className={'InputHelpText'}>{shortDateTimeFormat2(note.timestamp)}</div>
                <div className={'InputHelpText'}>{note.loggedInUser?.loginEmail} ({note.loggedInUser?.loginName})</div>
              </li>
            })}
          </ul>

          <h2>Actions</h2>

          <div>
            <ActionButton smaller secondary onClick={cancel}>
              Cancel this booking?
            </ActionButton>

            {(booking?.details?.paymentInfo?.prepaidPackage || booking?.details?.paymentInfo?.prepaidSingleClassCredit) &&
                <div className={'InputHelpText'}>The client will get a class credit back.</div>
            }
          </div>

          <br/>

          {isUnpaid && <>

            <div>
              <ActionButton smaller onClick={markAsPaid}>
                Manually mark as paid
              </ActionButton>
              <input className={''}
                     onChange={e => setNote(e.target.value)}
                     placeholder={'Enter a note here'}
                     value={note} type={'text'}/>
              <div className={'InputHelpText'}>Use this option if you've collected payment outside of Kensu</div>
            </div>
            <br/>
            <div>
              <ActionButton smaller disabled>
                Coming soon: Send invoice
              </ActionButton>
              <div className={'InputHelpText'}>Emails the client a payment link. You'll be notified when the client
                pays.
              </div>
            </div>
          </>}

        </div>
      </>}
    </div>
  </div>
}
